import { Component, OnInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef, ElementRef } from '@angular/core';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { CalculationService } from '../../services/calculation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApexChart, ChartComponent } from 'ng-apexcharts';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatSort } from '@angular/material/sort';
import { MatStepper } from '@angular/material/stepper';
import html2canvas from "html2canvas"
import { ALLOCATION, PORTFOLIO_BREAKDOWN, STATISTIC_DATA} from '../../models/data'
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProgressSpinnerComponentComponent } from '../progress-spinner-component/progress-spinner-component.component';
import {HttpClient} from '@angular/common/http';
import {
  HeatMapChartOptions, 
  PieChartOptions, 
  ColumnChartOptions, 
  BubbleChartOptions, 
  Statistic, 
  PortfolioBreakdown, 
  Category, 
  CategoryBreakdown, 
  Asset, 
  AssetBreakdown
} from '../../models/interfaces'

export interface StepType {
  label: string;
  fields: FormlyFieldConfig[];
}

@Component({
  selector: 'app-builder',
  templateUrl: './builder.component.html',
  styleUrls: ['./builder.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class BuilderComponent implements OnInit {

  payload:any;
  allocatedAmount:any;
  captureRatio:any;
  statisticsData:any;


  @ViewChild("stepper") stepper: MatStepper;

  @ViewChild("heatMapChart") heatMapChart: ChartComponent;
  public heatMapChartOptions: Partial<HeatMapChartOptions>;

  @ViewChild("pieChart") pieChart: ChartComponent;
  public pieChartOptions: Partial<PieChartOptions>;

  @ViewChild("columnChart") columnChart: ChartComponent;
  public columnChartOptions: Partial<ColumnChartOptions>;

  @ViewChild("bubbleChart") bubbleChart: ChartComponent;
  public bubbleChartOptions: Partial<BubbleChartOptions>;

  @ViewChild("rorChart") rorChart: ChartComponent;
  public rorChartOptions: Partial<HeatMapChartOptions>;

  public heatMapChartOptionsPrint: Partial<HeatMapChartOptions>;

  public pieChartOptionsPrint: Partial<PieChartOptions>;

  public columnChartOptionsPrint: Partial<ColumnChartOptions>;

  public bubbleChartOptionsPrint: Partial<BubbleChartOptions>;

  public rorChartOptionsPrint: Partial<HeatMapChartOptions>;
  public chartPrint: ApexChart;

  @ViewChild('categorySort', { static: true }) categorySort: MatSort;
  @ViewChildren('assetSort') assetSort: QueryList<MatSort>;
  @ViewChildren('assetTables') assetTables: QueryList<MatTable<Asset>>;

  categoriesDataSource: MatTableDataSource<Category>;
  categoriesData: Category[] = [];
  categoryColumnMap: Map<string, string> = new Map([
    ['category_name', 'Category Name'],
    ['category_percentage', 'Category Percentage'],
    ['category_value', 'Category Value'],
  ])
  assetColumnMap: Map<string, string> = new Map([
    ['asset_name', 'Asset Name'],
    ['asset_percentage', 'Asset Percentage'],
    ['asset_value', 'Asset Value'],
  ])
  categoryColumnsToDisplay = ['category_name', 'category_percentage', 'category_value'];
  assetColumnsToDisplay = ['asset_name', 'asset_percentage', 'asset_value'];
  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<Asset>>;

  ///
  breakdownDataSource: MatTableDataSource<CategoryBreakdown>;
  breakdownData: CategoryBreakdown[] = [];
  portfolioBreakdown: PortfolioBreakdown;


  categoryBreakdownColumnMap: Map<string, string> = new Map([
    ['category_name', 'Category Name'],
    ['category_rate_of_return', 'Rate of Return'],
    ['category_standard_deviation', 'Standard Deviation'],
    ['category_correlation', 'Correlation to S&P'],
    ['category_value', 'Value'],
    ['category_percentage', 'Percentage'],
  ])
  assetBreakdownColumnMap: Map<string, string> = new Map([
    ['asset_name', 'Asset Name'],
    ['asset_ticker', 'Ticker'],
    ['asset_rate_of_return', 'Rate of Return'],
    ['asset_standard_deviation', 'Standard Deviation'],
    ['asset_correlation', 'Correlation to S&P'],
    ['asset_value', 'Allocation'],
    ['asset_percentage', 'Percentage'],
  ])

  categoryBreakdownColumnsToDisplay = ['category_name', 'category_ticker', 'category_rate_of_return', 'category_standard_deviation', 'category_correlation', 'category_value', 'category_percentage'];
  assetBreakdownColumnsToDisplay = ['asset_name', 'asset_ticker', 'asset_rate_of_return', 'asset_standard_deviation', 'asset_correlation', 'asset_value', 'asset_percentage'];
  @ViewChild('breakdownOuterSort', { static: true }) breakdownSort: MatSort;
  @ViewChildren('breakdownInnerSort') breakdownInnerSort: QueryList<MatSort>;
  @ViewChildren('breakdownInnerTables') breakdownInnerTables: QueryList<MatTable<AssetBreakdown>>;

  expandedCategoryBreakdown: CategoryBreakdown | null;


  expandedCategory: Category | null;
  portfolioForm: FormGroup;

  statisticDataSource: MatTableDataSource<Statistic> = new MatTableDataSource<Statistic>(STATISTIC_DATA);
  statisticDisplayedColumns: string[] = ['metric', 'value'];


  category: string;
  ticker: string;
  rate_of_return: number;
  standard_deviation: number;
  correlation: number;
  current_allocation: number;
  current_percentage: number;
  Formatdate: any;
  // breakdownDataSource: MatTableDataSource<CategoryBreakdown> = new MatTableDataSource<CategoryBreakdown>(BREAKDOWN);
  breakdownDisplayedColumns: string[] = ['category', 'ticker', 'rate_of_return', 'standard_deviation', 'correlation', 'current_allocation', 'current_percentage'];

  portfolioValueTotal: number;
  portfolioPercentageTotal: number;
  constructor(private currencyPipe: CurrencyPipe, private percentPipe: PercentPipe, public calculationService: CalculationService,
    private snackBar: MatSnackBar, private cd: ChangeDetectorRef, private fb: FormBuilder, private decimalPipe: DecimalPipe, private router: Router,private dialog: MatDialog,private http:HttpClient) {

    this.portfolioPercentageTotal = 0;
    this.portfolioValueTotal = 0;
    this.chartPrint = {
      height: 400,
      width: 800,
      // width: '100%',
      type: 'heatmap',
      fontFamily: '"Open Sans Regular", sans-serif',
      animations: {
        enabled: false
      }
    }
    this.heatMapChartOptions = {
      series: [
        {
          name: "Tax-Free Cash",
          data: this.generateData(7, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Taxable Cash",
          data: this.generateData(6, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Corporate Bonds",
          data: this.generateData(5, {
            min: 0,
            max: 100
          })
        },
        {
          name: "High Yield Bonds",
          data: this.generateData(4, {
            min: 0,
            max: 100
          })
        },
        {
          name: "US Treasury (1-3 Years)",
          data: this.generateData(3, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Mid Cap Growth",
          data: this.generateData(2, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Large Cap Growth",
          data: this.generateData(1, {
            min: 0,
            max: 100
          })
        },
        // {
        //   name: "Small Cap Growth",
        //   data: this.generateData(0, {
        //     min: 0,
        //     max: 100
        //   })
        // }
      ],
      chart: {
        height: 600,
        width: 600,
        type: 'heatmap',
        fontFamily: '"Open Sans Regular", sans-serif',
        animations: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: true,
        dropShadow: {
          enabled: true,
          left: 0.5,
          top: 0.5,
          opacity: 0.5
        },
      },
      plotOptions: {
        heatmap: {
          reverseNegativeShade: true,
          colorScale: {
            // inverse: true,
            ranges: [
              {
                from: -1,
                to: 0,
                name: 'Negative',
                color: '#d32f2f',
              },
              {
                from: 0,
                to: 1,
                name: 'Positive',
                color: '#244768'
              },
            ]
          }
        }
      },
      colors: [
        // '#388e3c', // Mat Green 700
        // '#d32f2f', // Mat Red 700
        // '#fecd5c', // Chapwood Yellow
        '#244768', // Chapwood Blue Primary
      ],
      title: {
        text: '',
        align: 'left',
        style: {
          fontSize: '28px',
          fontFamily: '"Open Sans Regular", sans-serif',
          fontWeight: 600
        },
      },
      // colors: [
      //   "#F3B415",
      //   "#F27036",
      //   "#663F59",
      //   "#6A6E94",
      //   "#4E88B4",
      //   "#00A7C6",
      //   "#18D8D8",
      //   "#A9D794",
      //   "#46AF78",
      //   "#A93F55",
      //   "#8C5E58",
      //   "#2176FF",
      //   "#33A1FD",
      //   "#7A918D",
      //   "#BAFF29"
      // ],
      xaxis: {
        labels: {
          style: {
            fontSize: '10px',
          },
          trim: false,
        },
        type: "category",
        categories: [
          "Tax-Free Cash",
          "Taxable Cash",
          "Corporate Bonds",
          "High Yield Bonds",
          "US Treasury (1-3 Years)",
          "Small Cap Growth",
          "Mid Cap Growth",
          "Large Cap Growth",
        ],
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '12px',
          },
        },
      },
    };

    this.pieChartOptions = {
      series: [44, 55, 13, 43, 22],
      chart: {
        // height: 600,
        width: 650,
        type: "pie",
        fontFamily: '"Open Sans Regular", sans-serif',
        animations: {
          enabled: false
        }
      },
      title: {
        text: '',
        align: 'left',
        style: {
          fontSize: '28px',
          fontFamily: '"Open Sans Regular", sans-serif',
          fontWeight: 600,
        },
      },
      colors: [
        '#388e3c', // Mat Green 700
        '#d32f2f', // Mat Red 700
        '#fecd5c', // Chapwood Yellow
        '#244768', // Chapwood Blue Primary
        '#4C2A85', // Violet
        '#C37632', // Orange Copper
        '#EE33FF', // Pink Fuschia
        '#22BF88', // Ocean Green
        '#86809D', // Rhythm Grey
        '#542F26', // Brown
      ],
      labels: ["Tax-Free Cash", "Corporate Bonds", "US Treasury (1-3 Years)", "Small Cap Growth", "Large Cap Growth"],
      legend: {
        fontSize: '16px'
      },
      dataLabels: {
        style: {
          fontSize: '16px'
        }
      },
      tooltip: {
        style: {
          fontSize: '16px'
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };

    this.columnChartOptions = {
      series: [
        {
          name: "Net Profit",
          data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
        },
        {
          name: "Revenue",
          data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
        },
        {
          name: "Free Cash Flow",
          data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
        }
      ],
      chart: {
        height: 600,
        width: 600,
        type: "bar",
        fontFamily: '"Open Sans Regular", sans-serif',
        animations: {
          enabled: false
        }
      },
      grid: {
        row: {
          colors: ["#efefef", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      colors: [
        // '#388e3c', // Mat Green 700
        // '#d32f2f', // Mat Red 700
        // '#fecd5c', // Chapwood Yellow
        '#244768', // Chapwood Blue Primary
      ],
      title: {
        text: '',
        align: 'left',
        style: {
          fontSize: '28px',
          fontFamily: '"Open Sans Regular", sans-serif',
          fontWeight: 600
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "<-5%",
          "-5% to -4%",
          "-4% to -3%",
          "-3% to -2%",
          "-2% to -1%",
          "-1% to 0%",
          "0% to 1%",
          "1% to 2%",
          "2% to 3%",
          "3% to 4%",
          "4% to 5%",
          ">5%",
        ]
      },
      yaxis: {
        title: {
          text: "Frequency",
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
      }
    };
    let test: any = [10, 10, 20]
    this.bubbleChartOptions = {

      series: [
        {
          name: "S&P 500",
          data: [
            test
          ],
        },
      ],
      chart: {
        height: 600,
        width: 600,
        type: 'scatter',
        animations: {
          enabled: false
        },
        toolbar: {
          tools: {
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            reset: false,
            pan: false
          }
        }
      },
      grid: {
        row: {
          colors: ["#efefef", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        opacity: 0.8
      },
      title: {
        text: '',
        align: 'left',
        style: {
          fontSize: '28px',
          fontFamily: '"Open Sans Regular", sans-serif',
          fontWeight: 600
        },
      },
      colors: [
        '#388e3c', // Mat Green 700
        // '#d32f2f', // Mat Red 700
        // '#fecd5c', // Chapwood Yellow
        '#244768', // Chapwood Blue Primary
      ],
      xaxis: {
        min: 0,
        tickAmount: 5,
        title: {
          text: 'Standard Deviation',
          style: {
            fontSize: '16px',
            fontFamily: '"Open Sans Regular", sans-serif',
          },
        },
      },
      yaxis: {
        min: 0,
        tickAmount: 5,
        title: {
          text: 'Rate of Return',
          style: {
            fontSize: '16px',
            fontFamily: '"Open Sans Regular", sans-serif',
          },
        },
      },
      plotOptions: {
        bubble: {
          minBubbleRadius: 20,
          maxBubbleRadius: 20,
        }
      }
    };

    this.rorChartOptions = {
      series: [
        {
          name: "Tax-Free Cash",
          data: this.generateData(7, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Taxable Cash",
          data: this.generateData(6, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Corporate Bonds",
          data: this.generateData(5, {
            min: 0,
            max: 100
          })
        },
        {
          name: "High Yield Bonds",
          data: this.generateData(4, {
            min: 0,
            max: 100
          })
        },
        {
          name: "US Treasury (1-3 Years)",
          data: this.generateData(3, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Mid Cap Growth",
          data: this.generateData(2, {
            min: 0,
            max: 100
          })
        },
        {
          name: "Large Cap Growth",
          data: this.generateData(1, {
            min: 0,
            max: 100
          })
        },
        // {
        //   name: "Small Cap Growth",
        //   data: this.generateData(0, {
        //     min: 0,
        //     max: 100
        //   })
        // }
      ],
      chart: {
        height: 600,
        width: 600,
        // width: '100%',
        type: 'heatmap',
        fontFamily: '"Open Sans Regular", sans-serif',
        animations: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: true,
        dropShadow: {
          enabled: true,
          left: 0.5,
          top: 0.5,
          opacity: 0.5
        },
      },
      plotOptions: {
        heatmap: {
          reverseNegativeShade: true,
          colorScale: {
            // inverse: true,
            ranges: [
              {
                from: -5,
                to: 0,
                name: 'Negative',
                color: '#d32f2f',
              },
              {
                from: 0,
                to: 5,
                name: 'Positive',
                color: '#244768'
              },
            ]
          }
        }
      },
      // colors: [
      //   // '#388e3c', // Mat Green 700
      //   // '#d32f2f', // Mat Red 700
      //   // '#fecd5c', // Chapwood Yellow
      //   '#244768', // Chapwood Blue Primary
      // ],
      title: {
        text: '',
        align: 'left',
        style: {
          fontSize: '28px',
          fontFamily: '"Open Sans Regular", sans-serif',
          fontWeight: 600
        },
      },
      // colors: [
      //   "#F3B415",
      //   "#F27036",
      //   "#663F59",
      //   "#6A6E94",
      //   "#4E88B4",
      //   "#00A7C6",
      //   "#18D8D8",
      //   "#A9D794",
      //   "#46AF78",
      //   "#A93F55",
      //   "#8C5E58",
      //   "#2176FF",
      //   "#33A1FD",
      //   "#7A918D",
      //   "#BAFF29"
      // ],
      xaxis: {
        labels: {
          style: {
            fontSize: '14px',
          },
          trim: false,
        },
        type: "category",
        categories: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
          "YTD"
        ],
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '10px',
          },
        },
      },
    };
  }
  model: any = {};
  fields: FormlyFieldConfig[] = [
    {
      key: 'customerName',
      type: 'input',
      templateOptions: {
        label: 'Enter Customer Name',
        required: true,
        blur: (formlyFieldConfig: FormlyFieldConfig) => {
          if (this.model.customerName) {
            let value1: string = (this.model.customerName as string);
            formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'customerName').formControl.patchValue(value1);
          }
        }
      },
      modelOptions: {
        updateOn: 'blur'
      }
    },
    {
      key: 'portfolioValue',
      type: 'input',
      templateOptions: {
        label: 'Portfolio Value',
        required: true,
        blur: (formlyFieldConfig: FormlyFieldConfig) => {
          if (this.model.portfolioValue) {
            let value: string = (this.model.portfolioValue as string).replace(/[^0-9.-]+/g, '');
            formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'portfolioValue').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
          }
        }
      },
      modelOptions: {
        updateOn: 'blur'
      }
    }
  ]
  form: FormGroup = new FormGroup({});
  options: FormlyFormOptions = {};

  ngOnInit(): void {
    this.portfolioForm = this.fb.group({
      // portfolioValue: [null, { validators: [Validators.required], updateOn: 'blur' }],
      portfolioValue: this.form,
      allocationTable: new FormGroup({})
    })
    // this.portfolioForm = new FormGroup({
    //   'portfolioValue': new FormControl(null, Validators.required, ),
    //   'allocationTable': new FormGroup({}),
    // });
    this.initializeDataSource();
    this.initializeBreakdownTable();
    this.getFormatdate();
  }

  toggleRow(category: Category) {
    // this.setAssetAllocations((category.assets as MatTableDataSource<Asset>).data.length);
    category.assets && (category.assets as MatTableDataSource<Asset>).data.length ? (this.expandedCategory = this.expandedCategory === category ? null : category) : null;
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<Asset>).sort = this.innerSort.toArray()[index]);
  }


  toggleCategoryBreakdownRow(categoryBreakdown: CategoryBreakdown) {
    // this.setAssetAllocations((category.assets as MatTableDataSource<Asset>).data.length);
    categoryBreakdown.assetBreakdowns && (categoryBreakdown.assetBreakdowns as MatTableDataSource<AssetBreakdown>).data.length ? (this.expandedCategoryBreakdown = this.expandedCategoryBreakdown === categoryBreakdown ? null : categoryBreakdown) : null;
    this.cd.detectChanges();
    this.breakdownInnerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<AssetBreakdown>).sort = this.breakdownInnerSort.toArray()[index]);
  }


  activedStep = 0;

  tableData: any;

  isSubmitted: boolean = false;
  isBroke: boolean = false;

  prevStep(step) {
    this.activedStep = step - 1;
  }

  nextStep(step) {
    this.activedStep = step + 1;
  }

  toFixedNumber(num, digits, base) {
    var pow = Math.pow(base || 10, digits);
    return Math.round(num * pow) / pow;
  }


  submit() {
    window.scrollTo(0,0)
    let dialogRef: MatDialogRef<ProgressSpinnerComponentComponent> = this.dialog.open(ProgressSpinnerComponentComponent, {
      panelClass: 'transparent',
      disableClose: true,
    })
    let categories = Object.entries(this.portfolioForm.get('allocationTable').value).filter(([k, v]) => {
      if (v instanceof Object) {
        return [k, v];
      }
    }).map(([k, v]) => {
      if (v instanceof Object) {
        let assets = Object.entries(v).filter(([key, value]) => {
          let idx = key.indexOf("-percentage");
          if (idx >= 0) {
            return [key, value]
          }
        }).map(([key, value]) => {
          let idx = key.indexOf("-percentage");
          return {
            asset_name: key.substring(0, idx),
            asset_percentage: value ? this.convertToNumber(value) : 0,
          };
        })
        return {
          category_name: k,
          ASSETS: assets
        };
      }
    })
    this.model.allocation_table = {
      CATEGORIES: categories
    };
    // console.log(categories);
    let values=categories.map(asset=>asset.ASSETS.map(a=>a.asset_percentage !==0? (a.asset_percentage/100) * this.convertToNumber(this.model.portfolioValue) : 0));
    let merged = [].concat.apply([], values);
    this.allocatedAmount=merged
    // let obj={
    //   amount:this.convertToNumber(this.model.portfolioValue),
    //   allocation:merged
    // }

    const builderPayload = {
      portfolio_value: this.model.portfolioValue ? this.convertToNumber(this.model.portfolioValue) : 0,
      allocation_table: this.model.allocation_table,
      amount:this.convertToNumber(this.model.portfolioValue),
      allocation:merged
    };
    this.payload=builderPayload;



    this.calculationService.addBuilder(builderPayload).subscribe((response: any) => {
      this.isSubmitted = true;
      // Display success message
      this.snackBar.open(response?.message, 'Close', {
        panelClass: 'success-bg',
        duration: 2500
      });
      let createdBuilder = response.createdBuilder;
      // Update Statistics
      let statisticData = createdBuilder.statistic;
      this.statisticsData=createdBuilder.statistic;
      let statistic: Statistic[] = [
        { metric: 'Rate of Return', value: this.percentPipe.transform(statisticData.rate_of_return, '1.0-2') },
        { metric: 'Standard Deviation', value: this.percentPipe.transform(statisticData.standard_deviation, '1.0-2') },
        { metric: 'Variance Drag Phantom Tax', value: this.decimalPipe.transform(statisticData.variance_drag_phantom_tax, '1.0-2') },
        { metric: 'Sharpe Ratio', value: this.decimalPipe.transform(statisticData.sharpe_ratio, '1.0-2') },
        { metric: 'Probability of Any Loss in the Next 12 Months', value: this.percentPipe.transform(statisticData.probability_of_any_loss, '1.0-2') },
        { metric: 'Amount of Money at Risk in the Next 12 Months', value: this.currencyPipe.transform(statisticData.amount_of_money_at_risk, 'USD', 'symbol-narrow', '1.0-0') },
        { metric: 'Upper Return', value: this.percentPipe.transform(statisticData.upper_return, '1.0-2') },
        { metric: 'Lower Return', value: this.percentPipe.transform(statisticData.lower_return, '1.0-2') },
        { metric: 'Beta to the S&P 500', value:this.decimalPipe.transform(statisticData?.beta, '1.2-2')},
        // { metric: 'Upside Capture Ratio', value:this.decimalPipe.transform(statisticData?.capture_ratio?.upside_capture_ratio, '1.2-2')},
        // { metric: 'Downside Capture Ratio', value:this.decimalPipe.transform(statisticData?.capture_ratio?.downside_capture_ratio, '1.2-2')},
        { metric: 'Ulcer Index', value:this.decimalPipe.transform(statisticData?.ulcer_index, '1.2-2') + "%"},
      ];
      this.statisticDataSource = new MatTableDataSource<Statistic>(statistic);

      // Update Portfolio Breakdown Table
      this.breakdownData = [];
      this.portfolioBreakdown = createdBuilder.portfolio_breakdown;
      this.portfolioBreakdown.categoryBreakdowns.forEach(categoryBreakdown => {
        if (categoryBreakdown.assetBreakdowns && Array.isArray(categoryBreakdown.assetBreakdowns) && categoryBreakdown.assetBreakdowns.length) {
          this.breakdownData = [...this.breakdownData, { ...categoryBreakdown, assetBreakdowns: new MatTableDataSource(categoryBreakdown.assetBreakdowns) }];
        } else {
          this.breakdownData = [...this.breakdownData, categoryBreakdown];
        }
      })

      this.breakdownDataSource = new MatTableDataSource(this.breakdownData);
      this.breakdownDataSource.sort = this.breakdownSort;


      // Update Allocation Table/Chart
      this.pieChartOptions.series = [];
      this.pieChartOptions.labels = [];
      let assetWeights: [] = createdBuilder.asset_weights;
      assetWeights.forEach(weight => {
        let obj = Object.entries(weight);
        if (obj[0][1] > 0) {
          this.pieChartOptions.series.push(obj[0][1] as number)
          this.pieChartOptions.labels.push(obj[0][0]);
        }
      });
      // Need data to come up with table

      // Update Correlation Matrix
      let correlationArray: [] = createdBuilder.correlation_matrix;
      let resultArray = [];
      let resultIndices = [];
      let resultNames = [];

      for (let i = 0; i < assetWeights.length; i++) {
        let obj = Object.entries(assetWeights[i]);
        if (obj[0][1] > 0) {
          resultArray.push(
            {
              index: i,
              name: obj[0][0],
            }
          )
          resultIndices.push(i);
          resultNames.push(obj[0][0])
        }
      }
      for (let i = 0; i < resultArray.length; i++) {
        let newArray = [];
        resultIndices.forEach(idx => {
          // newArray.push(correlationArray[resultArray[i].index][idx]);
          newArray.push((Math.round(correlationArray[resultArray[i].index][idx] * 100) / 100).toFixed(2));
          // (Math.round(monthlyReturns[i] * 100) / 100).toFixed(2)
        })
        resultArray[i].array = newArray;
      }

      //Update X axis cateogies
      this.heatMapChartOptions.xaxis.categories = []
      this.heatMapChartOptions.xaxis.categories.push(resultNames);
      this.heatMapChartOptions.series = [];

      this.heatMapChartOptions.xaxis = {
        labels: {
          style: {
            fontSize: '11px',
          },
          trim: false,
        },
        type: "category",
        categories: resultNames,
      };

      this.heatMapChartOptions.yaxis = {
        labels: {
          style: {
            fontSize: '11px',
          },
        },
      };
      //Update Values
      for (let i = 0; i < resultArray.length; i++) {
        this.heatMapChartOptions.series.push({
          name: resultArray[i].name,
          // data: resultArray[i].array.slice(0, resultArray.length - i)
          data: resultArray[i].array
        });
        // {
        //   name: "Tax-Free Cash",
        //   data: this.generateData(7, {
        //     min: 0,
        //     max: 100
        //   })
        // },
      }

      // Update Monthly Return Histogram
      let monthlyReturns: number[] = createdBuilder.monthly_returns;
      let monthlyReturnMap: Map<String, []> = new Map();
      let monthlyReturnArray = Array(12).fill(0);
      monthlyReturns.forEach(ret => {
        if (ret < -5) {
          monthlyReturnArray[0] += 1
        }
        else if (ret > 5) {
          monthlyReturnArray[11] += 1
        }
        else {
          let adjRet = Math.floor(ret) + 6
          monthlyReturnArray[adjRet] += 1
        }
      });
      this.columnChartOptions.series = [
        {
          name: "Monthly Returns",
          data: monthlyReturnArray
        },
      ]

      // Update Annualized Risk vs Return
      // parseInt((Math.round(statisticData.rate_of_return * 100) / 100).toFixed(2)), parseInt((Math.round(statisticData.standard_deviation * 100) / 100).toFixed(2))
      let bubbleX = parseFloat((statisticData.standard_deviation * 100).toFixed(2));
      let bubbleY = parseFloat((statisticData.rate_of_return * 100).toFixed(2))
      let snp: any = [16, 9, 20]
      let port: any = [bubbleX, bubbleY, 10]
      this.bubbleChartOptions.series = [
        {
          name: "S&P 500",
          data: [
            snp
          ],
        },
        {
          name: "Proposed Portfolio",
          data: [
            port
          ],
        }
      ];
      // this.bubbleChartOptions.xaxis.max = bubbleX + 5
      // this.bubbleChartOptions.yaxis.max = bubbleY + 5
      this.bubbleChartOptions.xaxis = {
        min: 0,
        max: Math.floor(Math.max(bubbleX + 5, 21)),
        tickAmount: 5,
        title: {
          text: 'Annual Volatility',
          style: {
            fontSize: '16px',
            fontFamily: '"Open Sans Regular", sans-serif',
          },
        },
      }
      this.bubbleChartOptions.yaxis = {
        min: 0,
        max: Math.floor(Math.max(bubbleY + 5, 13.5)),
        tickAmount: 5,
        title: {
          text: 'Annual Return',
          style: {
            fontSize: '16px',
            fontFamily: '"Open Sans Regular", sans-serif',
          },
        },
      }
      // Update Monthly Rate of Returns chart
      // Create a series for each year
      let numberOfMonths = monthlyReturns.length;
      let numberOfYears = Math.floor(numberOfMonths / 12)
      let remainder = numberOfMonths % 12;
      let newSeries = [];
      let startYear = 2007;
      let currentData = [];
      let minReturn = 1000000;
      let maxReturn = -1000000;
      let ytdReturn = 1
      // iterate through all full years

      for (let i = 0; i < numberOfMonths; i++) {
        if (i != 0 && i % 12 == 0) {
          currentData.push(this.percentPipe.transform((ytdReturn - 1), '1.0-2'));
          maxReturn = Math.max((ytdReturn - 1) * 100, maxReturn);
          minReturn = Math.min((ytdReturn - 1) * 100, minReturn);
          ytdReturn = 1;
          let currentSeries = {
            name: startYear,
            data: currentData,
          }
          newSeries.push(currentSeries);
          currentData = []
          startYear += 1
        }
        maxReturn = Math.max(monthlyReturns[i], maxReturn);
        minReturn = Math.min(monthlyReturns[i], minReturn);
        // currentData.push(monthlyReturns[i]);
        // currentData.push((Math.round(monthlyReturns[i] * 100) / 100).toFixed(2));
        ytdReturn *= 1 + (monthlyReturns[i] / 100);
        currentData.push(this.percentPipe.transform(monthlyReturns[i] / 100, '1.0-2'));
      }
      // Check if any left over
      if (currentData.length > 0) {
        for (let i = currentData.length; i < 12; i++) {
          currentData.push(this.percentPipe.transform(0, '1.0-2'));
        }
        currentData.push(this.percentPipe.transform((ytdReturn - 1), '1.0-2'));
        ytdReturn = 1;
        let currentSeries = {
          name: startYear,
          data: currentData,
        }
        newSeries.push(currentSeries);
      }


      this.rorChartOptions.series = newSeries;
      this.rorChartOptions.plotOptions.heatmap.colorScale.ranges[0].from = minReturn - 0.05;
      this.rorChartOptions.plotOptions.heatmap.colorScale.ranges[1].to = maxReturn + 0.05;
      this.rorChartOptions.plotOptions.heatmap.reverseNegativeShade = true

      // Navigate to next page
      // this.rorChartOptionsPrint = this.rorChartOptions;
      // this.rorChartOptionsPrint.chart = {
      //   height: 400,
      //   width: 800,
      //   type: 'heatmap',
      //   fontFamily: '"Open Sans Regular", sans-serif',
      //   animations: {
      //     enabled: false
      //   }
      // },

      this.stepper.next();
      // this.calculationService.page = 'analysis';
      dialogRef.close()
    }, error => {
      dialogRef.close()
      console.log(error);
      this.snackBar.open('Calculation Failed', 'Close', {
        panelClass: 'warn-bg',
        duration: 2500
      });
    });
  }
  generateData(count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

      series.push(y);
      i++;
    }
    return series;
  }
  convertToNumber(value: string) {
    //Only accepting ints for now
    return parseFloat(value.replace(/[^0-9.-]+/g, ''));
  }

  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;

  pdfDownload() {
    let self = this;//use this variable to access your class members inside then().
    html2canvas(this.screen.nativeElement).then(canvas => {
      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
      this.downloadLink.nativeElement.download = 'marble-diagram.png';
      this.downloadLink.nativeElement.click();
    });
  }

  // print() {
  //   const element = <HTMLElement> document.getElementsByClassName('print')[0];
  //   // element.style.display = 'block';
  //   setTimeout(function () { // wait until all resources loaded

  //     window.print(); // change window to winPrint
  //     // element.style.display = 'none';
  //     window.close(); // change window to winPrint
  //   }, 1000);
  // }

  getType()
 {
   let type=this.calculationService.page
   if(type=='')
   {
     return 'builder'
   }
   else {
     return type
   }
 }


  getPDF()
  {
    let type=this.getType()
    let payload={
      'type':type,
      'name':this.model.customerName,
      'api_payload':this.payload,
    }

    let dialogRef: MatDialogRef<ProgressSpinnerComponentComponent> = this.dialog.open(ProgressSpinnerComponentComponent, {
      panelClass: 'transparent',
      disableClose: true,
    })

    this.http.post(this.calculationService.getPDFURL(),payload,{responseType:'arraybuffer'})
    .subscribe(res=>{
      dialogRef.close()
      if(res.byteLength>5)
      {
      var blob = new Blob([res],{type:'application/pdf'});
      const filename="Portfolio_" + type +".pdf"
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      }
    },(err)=>{
      dialogRef.close()
      if(err)
      {
        console.log({err})
        this.snackBar.open('Something went wrong!', 'Close', {
          panelClass: 'warn-bg',
          duration: 2500
        });
      }

    })

  }

  getCSV(){
    let obj={
      "ror":this.statisticsData.rate_of_return,
      "sd":this.statisticsData.standard_deviation,
      "amount":this.convertToNumber(this.model.portfolioValue),
      "allocation":this.allocatedAmount
    }
    this.http.post(this.calculationService.getCaptureRatioCSV(),obj,{responseType:'arraybuffer'})
    .subscribe(response=>{
      var blob = new Blob([response],{type:'text/csv'});
      const filename="capure_ratio.csv"
      // saveAs(blob,filename)
    },(error)=>{
      console.log(error)
    })
  }


  getFormatdate() {
    const today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    this.Formatdate = mm + '/' + dd + '/' + yyyy;
  }

  initializeDataSource() {
    // var assetAllocations = this.portfolioForm.get('currentAssetAllocation').get('assetAllocations') as FormArray;
    var portfolioValue = this.portfolioForm.get('portfolioValue') as FormControl;
    // this.portfolioForm.get('currentAssetAllocation').get('portfolioValue').setValue(this.portfolioForm.get('wegnerAnalysis').get('earnedIncome').get('portfolioValue').value);
    // this.portfolioForm.get('wegnerAnalysis').get('earnedIncome').get('portfolioValue').valueChanges.subscribe(value => {
    //   this.portfolioForm.get('currentAssetAllocation').get('portfolioValue').patchValue(value);
    // })
    var allocationTable = this.portfolioForm.get('allocationTable') as FormGroup;
    ALLOCATION.categories.forEach(category => {
      var categoryForm = new FormGroup({});
      var categoryPercentage = 0;
      var categoryValue = 0;
      (category.assets as Array<Asset>).forEach(asset => {
        // TO-DO: Add asset valueto categoryForm
        var assetForm = new FormGroup({});
        // /^\d*\.?\d*$/
        // var assetFormPercentage = new FormControl(asset.asset_percentage, [Validators.min(0), Validators.max(100), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]);
        var assetFormPercentage = new FormControl(asset.asset_percentage, [Validators.min(0), Validators.max(100), Validators.pattern(/^\d*\.?\d*$/)]);
        var assetFormValue = new FormControl(asset.asset_value);
        assetFormPercentage.valueChanges.subscribe(percentage => {
          var assetValue = this.toFixedNumber(percentage * 0.01 * this.convertToNumber(this.model.portfolioValue), 0, 10);
          assetFormValue.patchValue(assetValue);
        })
        // var assetControl = new FormControl(asset.asset_percentage);

        // assetControl.valueChanges.subscribe(percentage => {
        //   categoryPercentage += Number(percentage);
        // })
        // categoryForm.addControl(asset.asset_name, assetControl);
        categoryForm.addControl(asset.asset_name + '-percentage', assetFormPercentage);
        categoryForm.addControl(asset.asset_name + '-value', assetFormValue);
        // categoryForm.addControl(asset.asset_name + '-value', new FormControl(asset.asset_percentage));
      })
      var categoryFormPercentage = new FormControl(categoryPercentage);
      var categoryFormValue = new FormControl(categoryFormValue);
      allocationTable.addControl(category.category_name + '-percentage', categoryFormPercentage);
      allocationTable.addControl(category.category_name + '-value', categoryFormValue);
      // allocationTable.addControl(category.category_name + '-percentage', new FormControl(categoryPercentage));
      allocationTable.addControl(category.category_name, categoryForm);
      categoryForm.valueChanges.subscribe((object) => {
        categoryPercentage = 0;
        categoryValue = 0;
        Object.keys(object).map(key => {
          if (key.includes('-percentage')) {
            categoryPercentage += Number(object[key]);
          }
          else {
            categoryValue += Number(object[key]);
          }
        });

        categoryFormPercentage.patchValue(categoryPercentage);
        // categoryFormPercentage.patchValue(this.percentPipe.transform(categoryPercentage / 100, '1.0-2'));
        categoryFormPercentage.updateValueAndValidity();
        categoryFormValue.patchValue(categoryValue);
        // categoryFormValue.patchValue(this.currencyPipe.transform(categoryValue, 'USD', 'symbol-narrow', '1.0-0'));
        categoryFormValue.updateValueAndValidity();

        // Updating totals
        let allocationTable = this.portfolioForm.get('allocationTable').value;
        this.portfolioPercentageTotal = 0;
        this.portfolioValueTotal = 0;
        Object.keys(allocationTable).map(key => {
          if (key.includes('-percentage')) {
            if (typeof allocationTable[key] === 'string') {
              allocationTable[key] = this.convertToNumber(allocationTable[key]);
            }
            // this.convertToNumber(allocationTable[key]));
            this.portfolioPercentageTotal += Number(allocationTable[key]);
          }
        });
        this.portfolioValueTotal = this.portfolioPercentageTotal * 0.01 * this.convertToNumber(this.model.portfolioValue);

        // categoryFormPercentage.patchValue(categoryPercentage);
        categoryFormPercentage.patchValue(this.percentPipe.transform(categoryPercentage / 100, '1.0-2'));
        categoryFormPercentage.updateValueAndValidity();
        // categoryFormValue.patchValue(categoryValue);
        categoryFormValue.patchValue(this.currencyPipe.transform(categoryValue, 'USD', 'symbol-narrow', '1.0-0'));
        categoryFormValue.updateValueAndValidity();

      })

      categoryForm.setParent(this.portfolioForm.get('allocationTable') as FormGroup);

      // Normalize assets into a raw array
      const rawAssets = Array.isArray(category.assets) 
        ? category.assets 
        : category.assets.data; // MatTableDataSource stores the array in .data
      
      // Create a sorted copy for display
      const sortedAssets = [...rawAssets].sort((asset1, asset2) => {
        // If display_order is missing, treat it as very large so it falls to the bottom
        const asset1DisplayOrder = asset1.display_order ?? 9999;
        const asset2DisplayOrder = asset2.display_order ?? 9999;
        return asset1DisplayOrder - asset2DisplayOrder;
      })

      if (sortedAssets.length) {
        // Push into categoriesData using sorted assets
        this.categoriesData = [
          ...this.categoriesData, 
          { ...category, assets: new MatTableDataSource(sortedAssets) }
        ];
      } else {
        this.categoriesData = [...this.categoriesData, category];
      }
    })
    // this.portfolioForm.valueChanges.subscribe((object) => {
    //   // console.log(object);
    //   let allocationTable = this.portfolioForm.get('allocationTable');
    //   this.portfolioPercentageTotal = 0;
    //   this.portfolioValueTotal = 0;

    //   Object.keys(allocationTable).map(key => {
    //     if (key.includes('-percentage')) {
    //       this.portfolioPercentageTotal += Number(allocationTable[key]);
    //     }
    //     // else {
    //     //   this.portfolioValueTotal += Number(object[key]);
    //     // }
    //   });
    //   this.portfolioValueTotal = this.portfolioPercentageTotal * 0.01 * this.convertToNumber(this.model.portfolioValue);
    //   console.log('Percentage: ' + this.portfolioPercentageTotal);
    //   console.log('Value: ' + this.portfolioValueTotal);
    // })
    this.categoriesDataSource = new MatTableDataSource(this.categoriesData);
    this.categoriesDataSource.sort = this.sort;
  }

  initializeBreakdownTable() {
    this.portfolioBreakdown = PORTFOLIO_BREAKDOWN;
    PORTFOLIO_BREAKDOWN.categoryBreakdowns.forEach(categoryBreakdown => {
      if (categoryBreakdown.assetBreakdowns && Array.isArray(categoryBreakdown.assetBreakdowns) && categoryBreakdown.assetBreakdowns.length) {
        this.breakdownData = [...this.breakdownData, { ...categoryBreakdown, assetBreakdowns: new MatTableDataSource(categoryBreakdown.assetBreakdowns) }];
      } else {
        this.breakdownData = [...this.breakdownData, categoryBreakdown];
      }
    })

    this.breakdownDataSource = new MatTableDataSource(this.breakdownData);
    this.breakdownDataSource.sort = this.breakdownSort;
  }

}


